import * as breakpoints from "../styles/breakpoints";
import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import CheckboxIcon from "./icons/CheckboxIcon";
import CheckedIcon from "./icons/CheckedIcon";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	row: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
		userSelect: "none",
	},
	rowDisabled: {
		cursor: "not-allowed",
	},
	fullWidth: {
		width: "100%",
	},
	iconContainer: {
		position: "relative",
		width: 18,
		height: 18,
		margin: "auto",
		fill: colors.docketDarkGrey5,

		[breakpoints.desktopTrue]: {
			":hover": {
				fill: colors.docketLightishBlue,
			},
		},
	},
	iconContainerDisabled: {
		opacity: 0.5,
		[breakpoints.desktopTrue]: {
			":hover": {
				fill: colors.docketDarkGrey5,
			},
		},
	},
	checkboxIcon: {
		width: 18,
		height: 18,
		fill: "inherit",
		opacity: 0.54,
	},
	checkedIcon: {
		width: 18,
		height: 18,
		fill: colors.docketLightishBlue,
		stroke: "rgba(154,50,50,0)",
		strokeWidth: 1,
		position: "absolute",
		transition: "opacity 300ms",
		left: 0,
		opacity: 0,

		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 0.5,
			},
		},
	},
	checkedIconDisabled: {
		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 0,
			},
		},
	},
	visible: {
		opacity: 1,

		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 1,
			},
		},
	},
});

export default class EnhancedCheckbox extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesIcon: docketPropTypes.aphroditeStyles,
		aStylesIconChecked: docketPropTypes.aphroditeStyles,
		aStylesIconContainer: docketPropTypes.aphroditeStyles,
		aStylesLabel: docketPropTypes.aphroditeStyles,
		checked: PropTypes.bool,
		disabled: PropTypes.bool.isRequired,
		label: PropTypes.string,
		onCheck: PropTypes.func,

		children: PropTypes.node,
		fullWidth: PropTypes.bool,
		onDoubleClick: PropTypes.func,
	};

	static defaultProps = {
		disabled: false,
	};

	state = {
		checked: this.props.checked,
	};

	onCheck = () => {
		if (this.props.disabled) {
			return;
		}

		if (Date.now() - this._touchEndTime < 100) {
			return;
		}

		if (this.props.onCheck) {
			this.props.onCheck();
		} else if (this.props.checked !== true && this.props.checked !== false) {
			this.setState({ checked: !this.state.checked });
		}
	};

	componentDidUpdate() {
		if (this.props.checked !== this.state.checked) {
			this.setState({ checked: this.props.checked });
		}
	}

	_handleDoubleClick = e => {
		e.preventDefault();
		if (this.props.disabled) {
			return;
		}

		if (this.props.onDoubleClick) {
			this.props.onDoubleClick();
		}
	};

	_handleTouchStart = () => {
		if (this.props.disabled) {
			return;
		}

		this._touchStartTime = Date.now();
	};

	_handleTouchEnd = () => {
		if (this.props.disabled) {
			return;
		}

		const diff = Date.now() - this._touchStartTime;
		if (this.props.onDoubleClick && diff >= 600 && diff <= 5000) {
			this.props.onDoubleClick();
			this._touchEndTime = Date.now();
		}
	};

	_renderLabel = () => {
		return (
			<div className={css(appStyles.baseFont, this.props.aStylesLabel)}>
				{this.props.label}
			</div>
		);
	};

	render() {
		const checked =
			this.props.checked === false || this.props.checked === true
				? this.props.checked
				: this.state.checked;

		return (
			<a
				className={css(
					styles.row,
					this.props.fullWidth && styles.fullWidth,
					this.props.aStyles,
					this.props.disabled && styles.rowDisabled,
				)}
				onClick={this.onCheck}
				onTouchStart={this._handleTouchStart}
				onTouchEnd={this._handleTouchEnd}
				onDoubleClick={this._handleDoubleClick}
			>
				<div className={css(this.props.aStylesIconContainer)}>
					<div
						className={css(
							styles.iconContainer,
							this.props.disabled && styles.iconContainerDisabled,
						)}
					>
						<CheckboxIcon
							className={css(styles.checkboxIcon, this.props.aStylesIcon)}
						/>
						<CheckedIcon
							className={css(
								styles.checkedIcon,
								this.props.aStylesIcon,
								this.props.aStylesIconChecked,
								this.props.disabled && styles.checkedIconDisabled,
								checked && styles.visible,
							)}
						/>
					</div>
				</div>
				{this.props.label ? this._renderLabel() : this.props.children}
			</a>
		);
	}
}
